import React from 'react'
import {
    Box,
    Typography,
    Stack,
} from '@mui/material'

const NotFound = () => {
    return (
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh" }}>
            <Stack gap="20px" alignItems="center" color="#fff">
                <Typography variant="h6">No results found...</Typography>
            </Stack>
        </Box>
    )
}

export default NotFound;